"use client";

import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function FAQSection() {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const faqs = [
        {
            question: "O que são SapiensCoins?",
            answer: "SapiensCoins ($C) é a moeda da Sapieduca IA. Cada geração de conteúdo consome uma quantidade de créditos. Com o plano Essencial, você recebe 1.000 $C diários para usar como quiser."
        },
        {
            question: "Posso cancelar minha assinatura?",
            answer: "Sim! Você pode cancelar sua assinatura Pro a qualquer momento, sem dificuldades. Não há compromissos de longo prazo nem taxas ocultas de cancelamento."
        },
        {
            question: "Meus dados estão seguros?",
            answer: "Segurança é prioridade. Utilizamos criptografia de ponta a ponta e estamos em total conformidade com a LGPD. Seus planos e dados pedagógicos são estritamente privados."
        },
        {
            question: "O plano Escolas é para minha secretaria?",
            answer: "Exatamente! Este plano é nossa solução B2G voltada para redes municipais, estaduais e grandes grupos educacionais. Contate-nos para uma proposta personalizada."
        },
        {
            question: "Há suporte em Português?",
            answer: "Sim! Todo o nosso suporte é realizado por humanos, em português, e focado especificamente nas dores e necessidades dos educadores brasileiros."
        },
        {
            question: "Como funciona a indicação?",
            answer: "Basta compartilhar seu link único de indicação. Cada vez que um colega se cadastrar através dele, você e seu colega recebem créditos bônus automaticamente."
        }
    ];

    const toggleAccordion = (index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section id="FAQ" className="py-24 bg-slate-50 relative overflow-hidden">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-black text-slate-900 mb-4 tracking-tight">Perguntas Frequentes</h2>
                    <div className="w-24 h-1.5 bg-[#3266cc] mx-auto rounded-full"></div>
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`group bg-white rounded-3xl border transition-all duration-300 ${activeIndex === index
                                    ? "border-[#3266cc] shadow-xl shadow-blue-500/5 ring-1 ring-[#3266cc]/10"
                                    : "border-slate-100 shadow-sm hover:border-slate-300"
                                }`}
                        >
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full px-8 py-7 flex justify-between items-center text-left"
                            >
                                <span className={`text-lg font-bold transition-colors ${activeIndex === index ? "text-[#3266cc]" : "text-slate-800"
                                    }`}>
                                    {faq.question}
                                </span>
                                <div className={`flex-shrink-0 w-8 h-8 rounded-full border flex items-center justify-center transition-all ${activeIndex === index
                                        ? "bg-[#3266cc] border-[#3266cc] text-white rotate-0"
                                        : "bg-slate-50 border-slate-200 text-slate-400"
                                    }`}>
                                    {activeIndex === index ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
                                </div>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${activeIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                                }`}>
                                <div className="px-8 pb-8 text-slate-600 leading-relaxed font-medium text-lg">
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
